import { render } from "./TotalAmountTiles.vue?vue&type=template&id=ee8da0aa&scoped=true"
import script from "./TotalAmountTiles.vue?vue&type=script&lang=js"
export * from "./TotalAmountTiles.vue?vue&type=script&lang=js"

import "./TotalAmountTiles.vue?vue&type=style&index=0&id=ee8da0aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee8da0aa"]])

export default __exports__